module.exports = __webpack_public_path__ + "assets/img/zhifub.25559eec.jpg";